import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsIcon as Icon } from './src/Icon.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(Icon);
export const FsIcon = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-icon.js.map